import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './views/home/hazmat-home/home.component';
import { OurServicesComponent } from './views/our-services/our-services.component';
import { AboutUsComponent } from './views/about-us/about-us.component';
import { EquipmentComponent } from './equipment/equipment.component';
import { BasesComponent } from './bases/bases.component';
import { ContactComponent } from './contact/contact.component';
import { NewDetailComponent } from './new-detail/new-detail.component';
import { NewListComponent } from './new-list/new-list.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'servicios',
    component: OurServicesComponent
  },
  {
    path: 'nosotros',
    component: AboutUsComponent
  },
  {
    path: 'equipos',
    component: EquipmentComponent
  },
  {
    path: 'bases',
    component: BasesComponent
  },
  {
    path: 'contacto',
    component: ContactComponent
  },
  {
    path: 'novedades',
    component: NewListComponent
  },
  {
    path: 'detalle-novedad/:id',
    component: NewDetailComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
